import CmsBlock from "app/layout/cmsBlock";
import { MDBCol, MDBContainer, MDBRow } from "mdbreact";
import React from "react";

const Shop = () => {
  return <CmsBlock id="homepage_v2_shop" />;
};

export default Shop;
